import React, { useEffect, useState } from 'react';
import { StyledMBTACallout } from './MBTACallout.styles';
import { fetchMBTAcalloutData } from '../../api/mbtaCalloutService';
import { CarouselContainer } from '../../molecules/CarouselContainer';
import { Heading, Text, Types } from '@marriott/mi-ui-library';
import { MBTACalloutProps } from './MBTACallout.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MBTACallout: React.FC<MBTACalloutProps> = ({
  marshaCode,
  startDate,
  endDate,
  resCurrency,
  formDataHotelLocation,
  brandCodeProps,
  colorScheme,
}) => {
  const [mbta, setMbta] = useState<
    Array<{
      category: string;
      cta_label: string;
      enabled: string;
      cta_url: string;
      image_alt_text: string;
      subtitle: string;
      image: string;
      title: string;
      text: string;
      reservation_requirement: string;
      subcategory: string;
      event_date_enabled: string;
      name: string;
      description: string;
      url: string;
      imageUrl: string;
    }>
  >([]);
  const [hotelLocation, setHotelLocation] = useState('');
  const [loadMoreUrl, setLoadMoreUrl] = useState('');

  useEffect(() => {
    const arrivalDate = startDate?.replaceAll('-', '');
    const departureDate = endDate?.replaceAll('-', '');
    const scope = 'full';
    const currency = resCurrency || 'USD';

    setHotelLocation(formDataHotelLocation || 'your stay');
    setLoadMoreUrl(
      'https://activities.marriott.com/property/' +
        marshaCode +
        '?utm_source=marriott_com&utm_medium=travel_form&utm_campaign=prearrival&prearrival=expB&from=' +
        arrivalDate +
        '&to=' +
        departureDate
    );
    const fetchMBTAData = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const mbtaDataSample: any = {};
      mbtaDataSample.scope = scope;
      mbtaDataSample.code = marshaCode;
      mbtaDataSample.currency = currency;
      mbtaDataSample.from = arrivalDate;
      mbtaDataSample.to = departureDate;
      const mbtaData = await fetchMBTAcalloutData(mbtaDataSample, 'Our Favorites');
      setMbta(Array.isArray(mbtaData?.response) ? mbtaData.response : []);
    };
    fetchMBTAData();
  }, [marshaCode, startDate, endDate]);

  if (!mbta?.length) {
    return null;
  }

  return (
    <StyledMBTACallout>
      <div id="personalized-mbta-callout" className={`container mbta-container mbta-section ${colorScheme}`}>
        <Heading
          variation={Types.headingType.title}
          fontSize={Types.size.small}
          element={Types.tags.h3}
          titleText="Let the Exploring Begin"
          customClass="small-h6 mb-0 heading-top-margin"
        ></Heading>
        <Text
          element={Types.tags.paragraph}
          fontSize={Types.size.large}
          dangerouslySetInnerHTML={{
            __html: 'Discover the sights, flavors, and experiences that make ' + hotelLocation + ' unforgettable.',
          }}
          customClass="subtext mb-2"
        ></Text>
        <CarouselContainer
          amenitiesDetails={mbta}
          componentType="MBTA"
          arrivalDate={startDate}
          departureDate={endDate}
          eventId="Upcoming"
          componentEventId="MBTA_Callout"
          brandCode={brandCodeProps}
        ></CarouselContainer>

        <a href={loadMoreUrl} target="_blank" rel="noreferrer">
          <button className="m-button-secondary addButton custom-btn mx-0 ">Explore More Local Experiences</button>
        </a>
      </div>
    </StyledMBTACallout>
  );
};
